import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold'
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '20px 5px',
  },
  containerData: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  headings: {
    color: '#545456',
    fontSize: '14px',
  },
  cardWrapper: {
    margin: '20px 10px',
    padding: '10px 25px',
  },
  cardData: {
    fontSize: '12px',
    color: '#6F6F6F',
    paddingBottom: '5px'
  },
  cardValue: {
    fontSize: '20px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  }
}))

export { useStyles }